export class AdminSubscriptionCompanyCatalogMetrics {
  totalProducts: number

  activeProductsCount: number

  inactiveProductsCount: number

  productsWithStockControlCount: number

  outOfStockProductsCount: number

  productsWithPreparationTimeCount: number

  productsNeedKitchenCount: number

  reservationEnabledProductsCount: number

  mealsCount: number

  drinksCount: number

  genericFoodsCount: number

  combosCount: number

  extraServicesCount: number

  couponsCount: number

  promotionsCount: number

  tablesCount: number

  categoriesCount: number

  ordersCount: number

  manualExternalOrdersCount: number

  customersCount: number

  employeesCount: number

  couriersCount: number

  totalOrdersAmount: number

  manualExternalOrdersAmount: number

  manualExternalOrdersNetAmount: number

  averageTicketAmount: number

  constructor(data: Partial<AdminSubscriptionCompanyCatalogMetrics> = {}) {
    this.totalProducts = data.totalProducts ?? 0

    this.activeProductsCount = data.activeProductsCount ?? 0

    this.inactiveProductsCount = data.inactiveProductsCount ?? 0

    this.productsWithStockControlCount = data.productsWithStockControlCount ?? 0

    this.outOfStockProductsCount = data.outOfStockProductsCount ?? 0

    this.productsWithPreparationTimeCount = data.productsWithPreparationTimeCount ?? 0

    this.productsNeedKitchenCount = data.productsNeedKitchenCount ?? 0

    this.reservationEnabledProductsCount = data.reservationEnabledProductsCount ?? 0

    this.mealsCount = data.mealsCount ?? 0

    this.drinksCount = data.drinksCount ?? 0

    this.genericFoodsCount = data.genericFoodsCount ?? 0

    this.combosCount = data.combosCount ?? 0

    this.extraServicesCount = data.extraServicesCount ?? 0

    this.couponsCount = data.couponsCount ?? 0

    this.promotionsCount = data.promotionsCount ?? 0

    this.tablesCount = data.tablesCount ?? 0

    this.categoriesCount = data.categoriesCount ?? 0

    this.ordersCount = data.ordersCount ?? 0

    this.manualExternalOrdersCount = data.manualExternalOrdersCount ?? 0

    this.customersCount = data.customersCount ?? 0

    this.employeesCount = data.employeesCount ?? 0

    this.couriersCount = data.couriersCount ?? 0

    this.totalOrdersAmount = data.totalOrdersAmount ?? 0

    this.manualExternalOrdersAmount = data.manualExternalOrdersAmount ?? 0

    this.manualExternalOrdersNetAmount = data.manualExternalOrdersNetAmount ?? 0

    this.averageTicketAmount = data.averageTicketAmount ?? 0
  }
}
